import { createFeatureSelector } from '@ngrx/store';
import { configFeatureKey, State } from '../reducers/loyalty.reducer';
import { transferDataFeatureKey } from '../reducers/transferLoyaltyData.reducer';

export const selectLoyalty = createFeatureSelector<State>(configFeatureKey);
export const selectLoyaltyDataTransfer = createFeatureSelector<State>(transferDataFeatureKey);
